<template>
  <client-only>
    <div>
      <notifications
        v-for="group in groups"
        :key="group"
        :width="470"
        class="notification__plugin"
        :group="group"
        position="bottom center"
      >
        <template slot="body" slot-scope="props">
          <div
            :class="{ [props.item.type]: true }"
            class="notification-content_wrapper notification__content-wrapper"
          >
            <div class="notification-content notification__content">
              <div class="notification-icon notification__icon">
                <img
                  :src="
                    require(`@/checkoutForm/assets/icons/${props.item.type}.svg`)
                  "
                  :alt="`${props.item.type}`"
                  width="18"
                  height="18"
                />
              </div>
              <div class="notification-title notification__title">
                {{ props.item.title }}
              </div>
            </div>
            <div
              class="notification-close notification__close"
              @click="hideNotification({ group })"
            >
              <img
                :src="require(`@/checkoutForm/assets/icons/close.svg`)"
                alt="close"
                width="18"
                height="18"
              />
            </div>
          </div>
        </template>
      </notifications>
    </div>
  </client-only>
</template>

<script>
import notificationMixin from '@/checkoutForm/lib/notificationMixin';

export default {
  name: 'NotificationComponent',
  mixins: [notificationMixin],
  data: () => ({
    groups: ['success', 'error']
  })
};
</script>

<style lang="scss" scoped>
@import '../checkoutForm/styles/variables.scss';

.notification {
  &-content {
    display: flex;
    align-items: center;

    &_wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      text-align: left;
      justify-content: space-between;
      margin-bottom: 10px;
      background: $success-notification;
      border: 1px solid $text-color-secondary;
      padding: 12px 21px;
      box-sizing: border-box;
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15), 0 -2px 10px rgba(0, 0, 0, 0.2);
      border-radius: 3px;

      &.error {
        background: $error-notification;
        border: 1px solid #c70000;
      }

      @media (max-width: 768px) {
        max-width: 350px;
        margin: 0 auto 10px;
      }

      @media (max-width: 375px) {
        max-width: 280px;
      }
    }
  }

  &-title {
    font-family: Source Sans Pro, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 21px;
    color: $text-color-primary;
  }

  &-icon {
    img {
      max-width: 20px;
      max-height: 20px;
    }

    margin-right: 17px;
  }

  &-close {
    &:hover {
      cursor: pointer;
    }

    img {
      max-width: 20px;
      max-height: 20px;
    }
  }
}
</style>
